export const formatValue = (
  value: number | null | undefined,
  suffix: string = '',
  prefix: string = ''
): string => {
  if (value === null || value === undefined) return '-';
  return `${prefix}${value}${suffix}`;
};

export const formatCurrency = (value: number | null | undefined): string => {
  if (value === null || value === undefined) return '-';
  return `$${value.toLocaleString()}`;
};

export const formatPercentage = (value: number | null | undefined): string => {
  if (value === null || value === undefined) return '-';
  return `${value}%`;
};

export const formatRatio = (value: number | null | undefined): string => {
  if (value === null || value === undefined) return '-';
  return `${value}x`;
};

export const formatDateForHeader = (dateString: string): string => {
  const date = new Date(dateString);
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const year = date.getFullYear().toString().slice(-2);
  const hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const ampm = hours >= 12 ? 'pm' : 'am';
  const displayHours = hours % 12 || 12;

  return `${month}/${day}/${year}, ${displayHours}:${minutes}${ampm}`;
};

export const formatDateWithTime = (dateString: string): string => {
  const date = new Date(dateString);
  const month = date.toLocaleDateString('en-US', { month: 'long' });
  const day = date.getDate();
  const hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  const displayHours = hours % 12 || 12;

  return `${month} ${day}, ${displayHours}:${minutes} ${ampm}`;
};

export const formatCompanyWebsite = (
  website: string | null | undefined
): string => {
  if (!website) return 'Unknown Company';
  return website.replace(/^https?:\/\//, '').replace(/^www\./, '');
};
